// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Navbar from "./components/Navbar";
// import Footer from "./components/Footer";

// import Home from "./pages/Home";
// import About from "./pages/About";
// import Projects from "./pages/Projects";
// import Contact from "./pages/Contact";

// import ScrollToTop from "./components/ScrollToTop";

// import Security1 from "./pages/security/Security1";
// import Security2 from "./pages/security/Security2";
// import Security3 from "./pages/security/Security3";
// import Security4 from "./pages/security/Security4";
// import Security5 from "./pages/security/Security5";
// import Security6 from "./pages/security/Security6";

// import Facility1 from "./pages/facility/Facility1";
// import Facility2 from "./pages/facility/Facility2";
// import Facility3 from "./pages/facility/Facility3";
// import Facility4 from "./pages/facility/Facility4";
// import Facility5 from "./pages/facility/Facility5";

// export default function App() {
//   return (
//     <BrowserRouter>
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/projects" element={<Projects />} />
//         <Route path="/contact" element={<Contact />} />

//        <Route path="/security" element={<Security1 />} />
//         <Route path="/security/Security2" element={<Security2 />} />
//         <Route path="/security/Security3" element={<Security3 />} />
//         <Route path="/security/Security4" element={<Security4 />} />
//         <Route path="/security/Security5" element={<Security5 />} />
//         <Route path="/security/Security6" element={<Security6 />} />

//         <Route path="/facility" element={<Facility1 />} />
//         <Route path="/facility/Facility2" element={<Facility2 />} />
//         <Route path="/facility/Facility3" element={<Facility3 />} />
//         <Route path="/facility/Facility4" element={<Facility4 />} />
//         <Route path="/facility/Facility5" element={<Facility5 />} />
//       </Routes>
//       <Footer />
//     </BrowserRouter>
    
//   );
// }




import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";

import Security1 from "./pages/security/Security1";
import Security2 from "./pages/security/Security2";
import Security3 from "./pages/security/Security3";
import Security4 from "./pages/security/Security4";
import Security5 from "./pages/security/Security5";
import Security6 from "./pages/security/Security6";

import Facility1 from "./pages/facility/Facility1";
import Facility2 from "./pages/facility/Facility2";
import Facility3 from "./pages/facility/Facility3";
import Facility4 from "./pages/facility/Facility4";
import Facility5 from "./pages/facility/Facility5";

export default function App() {
  return (
    <BrowserRouter>
      {/* Scroll reset on route change */}
      <ScrollToTop />

      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />

        {/* Security Routes */}
        <Route path="/security" element={<Security1 />} />
        <Route path="/security/Security2" element={<Security2 />} />
        <Route path="/security/Security3" element={<Security3 />} />
        <Route path="/security/Security4" element={<Security4 />} />
        <Route path="/security/Security5" element={<Security5 />} />
        <Route path="/security/Security6" element={<Security6 />} />

        {/* Facility Routes */}
        <Route path="/facility" element={<Facility1 />} />
        <Route path="/facility/Facility2" element={<Facility2 />} />
        <Route path="/facility/Facility3" element={<Facility3 />} />
        <Route path="/facility/Facility4" element={<Facility4 />} />
        <Route path="/facility/Facility5" element={<Facility5 />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}